import mqtt from 'mqtt'
// import Vue from 'Vue'

let client = null
function getMqttapi () {
  // console.log(window.location.host, window.location.host.split(':')[0])
  if (window.location.host.split(':')[0] === 'localhost') {
    return 'ws://39.106.96.131:58884/mqtt'
  }
  // if (window.location.host.split(':')[0] === 'anfangwxtest.aimtyiot.cn') {
  //   return 'wss://' + window.location.host + '/wss'
  // }
  if (window.location.protocol === 'https:') {
    return 'wss://' + window.location.host + '/wss'
  } else {
    return 'ws://' + window.location.host + '/ws'
  }
}
// let timeOut = ''
// 开启订阅（登录成功后调用）
export const startSub = (vm, topc) => {
  if (client === null) {
    let options = {
      // clientId: 'aabbccddee',
      username: vm.$store.getters.get_token,
      password: vm.$store.getters.get_token,
      timeout: 5,
      keepAliveInterval: 50,
      cleanSession: false,
      useSSL: true
    }
    client = mqtt.connect(getMqttapi(), options)
    client.on('connect', () => {
      client.subscribe(topc)
      // 订阅所有设备相关主题
      console.log('连接mqtt成功，并已订阅相关主题')
    }).on('error', err => {
      console.log('连接mqtt报错', err)
      client.end()
      client.reconnect()
    }).on('message', (topic, message) => {
      // topic 消息头 message 消息体
      // byte数组，tostring转字符串
      let msg = message.toString()
      let msgJSON = JSON.parse(msg)
      // console.log('收到mqtt信息', msgJSON)
      if (msgJSON.key === 'defence') {
        console.log('defence', msgJSON)
        if (vm.$route.path === '/Device') {
          vm.golobleObject.defenceState(msgJSON)
        }
      } else if (msgJSON.key === 'door') {
        console.log('door', msgJSON)
        if (msgJSON.value === 'open') {
          vm.$store.commit('set_door_open', false)
          vm.$store.commit('set_door_suc', true)
          vm.golobleShow.getClickImg()
          setTimeout(function () {
            vm.$store.commit('set_door_open', true)
            vm.$store.commit('set_door_suc', false)
            vm.golobleShow.getClickImg()
          }, 1000)
        } else {
          vm.$store.commit('set_door_open', false)
          vm.$store.commit('set_door_err', true)
          vm.golobleShow.getClickImg()
          setTimeout(function () {
            vm.$store.commit('set_door_open', true)
            vm.$store.commit('set_door_err', false)
            vm.golobleShow.getClickImg()
          }, 1000)
        }
      } else if (msgJSON.datatype === 'alarm' || msgJSON.datatype === 'deviceinfo') {
        // console.log('504开关门状态', msgJSON)
        // 504 有两个通道 alarm deviceinfo
        if (vm.$route.path === '/Device') {
          vm.golobleObject.getMqttDoor(msgJSON)
        } else if (vm.$route.path === '/NewChildList') {
          vm.golobleObject.getMqttDoor(msgJSON)
        }
      } else {
        console.log('else', msgJSON)
      }
      // try {
      //   let msg = JSON.parse(message.toString())
      //   console.log('收到mqtt数据', msg)
      // } catch (e) {
      //   console.log('收到无法解析的消息类型')
      // }
    })
  }
}

// 关闭订阅（退出登录时调用）
export const closeSub = () => {
  console.log('已退出订阅')
  client && client.end()
  client = null
}
// 发消息给服务器
export const sendSub = (topic, msg) => {
  console.log(topic, msg)
  client.publish(topic, JSON.stringify(msg), function (a) {
  })
}



// WEBPACK FOOTER //
// ./src/mqtt/mqttMsg.js